import { responseRedirect } from './responseRedirect';
import { Sentry } from '~shared/sentry';

type RequestPayload = {
  response: Response;
  url: string;
  method: string;
  body?: string;
  headers?: Record<string, string>;
};

const CART_ITEM_DELETE_PATH = /\/cart\/cart_items\/\d+$/;

// Checkout prune can DELETE a cart item that is already gone (CLIENTS-6).
export const isExpectedCartItemDeleteNotFound = ({ url, method }: { url: string; method: string }): boolean =>
  method.toUpperCase() === 'DELETE' && CART_ITEM_DELETE_PATH.test(url);

export const handleBadRequest = ({ response, url, method, body, headers }: RequestPayload) => {
  if (response.status === 404 && !isExpectedCartItemDeleteNotFound({ url, method })) {
    Sentry.captureMessage(`404 received for url: ${url}`, {
      contexts: { body: { body }, url: { url }, method: { method }, response: { response }, headers: { headers } },
    });
  }

  responseRedirect(response);
};
